/**
 * http/https形式のURLとして有効な文字列かどうかを判定する。
 * AWS Parameter Storeは空文字を許容しないため、未設定を示すプレースホルダ値
 * （空文字以外の非URL文字列）が渡されるケースを弾く目的で使用する。
 */
export function isValidUrl(value: string): boolean {
  if (!value) {
    return false;
  }
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

export function getPathname() {
  // SSR対応
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.pathname;
}

type ChatLinkOptions = {
  isThread?: boolean;
};

/**
 * 指定したチャットIDへの直リンクURLを生成する。
 * スレッドページ（/community/:code/:chatId/threads）上でも
 * チャンネルベースURL（/community/:code）に正規化したうえで chatId を付与する。
 * isThread: true の場合は force_thread_display=true を付加する。
 */
export function getChatLink(chatId: number, options?: ChatLinkOptions): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const url = new URL(window.location.href);
  url.search = '';
  url.hash = '';

  // スレッドページの場合はチャンネルURLに戻す
  const threadPathMatch = url.pathname.match(/^(\/community\/[^/]+)\/\d+\/threads$/);
  if (threadPathMatch) {
    url.pathname = threadPathMatch[1];
  }

  url.searchParams.set('chatId', chatId.toString());
  if (options?.isThread) {
    url.searchParams.set('force_thread_display', 'true');
  }
  return url.toString();
}

export async function copyChatLinkToClipboard(
  chatId: number,
  options?: ChatLinkOptions,
): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }
  await navigator.clipboard.writeText(getChatLink(chatId, options));
}
